import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ScrollService, ScrollParams, ArtistService, SearchService, BasicSearchParams } from '../../api';
import * as _ from 'lodash';

@Component({
  selector: 'app-all-artist',
  templateUrl: './all-artist.component.html',
  styleUrls: ['./all-artist.component.css']
})
export class AllArtistComponent implements OnInit {
  private allArtists: Array<any>;
  private scrollParams = new ScrollParams();
  private scrollSubscriber = null;
  private loading = true;
  label: any = "";

  constructor(private artistService: ArtistService, private route: ActivatedRoute, private cdRef: ChangeDetectorRef,
    private scrollService: ScrollService, private router: Router, private searchService: SearchService) {
    this.allArtists = new Array<any>();
  }

  ngOnInit() {
    this.label = localStorage.getItem('labelName');
    this.allArtists = new Array<any>();
    this.getAllArtist(this.label);
    this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) => this.getAllArtist(this.label));
    this.cdRef.detectChanges();
  }
  getAllArtist(label) {
    this.loading = true;
    this.scrollService.toggleProgressBar(true);
    this.artistService.getArtists(label).toPromise().then((res: any) => {
      if (res.length > 0) {
        this.allArtists = res;
      }
    });
    let params = new BasicSearchParams(false, false, true, false, false);
    this.scrollParams.page++;
    this.allArtists = _.uniqBy(this.allArtists, 'id');
    if (this.allArtists.length < 0) {
      this.loading = false;
    }
  }

  resetScrollParams() {
    this.scrollParams = new ScrollParams();
  }

  ngOnDestroy() {
    if (this.scrollSubscriber != null) {
      this.scrollSubscriber.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/artists/all-artist/all-artist.component.ts